
// 1.

// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";
// import { TbRefresh } from "react-icons/tb";
// import { Paper, Typography, Box } from "@mui/material";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ChartDataLabels
// );

// function InvPrHorizontalPerformance() {
//   const chartRef = useRef();

//   const [selectedDate, setSelectedDate] = useState(() => {
//     return new Date().toISOString().split("T")[0];
//   });

//   const [idealValue, setIdealValue] = useState(80);
//   const [inverters, setInverters] = useState([]);
//   const [chartData, setChartData] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const credentials = {
//     LOGIN_ID: localStorage.getItem("LoginID"),
//     LOC_CODE: localStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//     TYP: "I",
//   };

//   const getValidatedDates = () => {
//     let start = selectedDate;
//     const nextDay = new Date(start);
//     nextDay.setDate(nextDay.getDate() + 1);

//     let end = nextDay.toISOString().split("T")[0];

//     return { start, end };
//   };

//   // 🔹 Fetch Inverters
//   useEffect(() => {
//     const fetchInverters = async () => {
//       try {
//         const res = await axios.get(
//           `${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`,
//           { params: credentials }
//         );
//         setInverters(res.data?.FEED || []);
//       } catch (err) {
//         console.error("Inverter API Error:", err);
//       }
//     };

//     fetchInverters();
//   }, []);

//   // 🔹 Fetch Chart Data
//   const fetchChartData = async () => {
//     if (!inverters?.length) return;

//     setLoading(true);
//     const { start, end } = getValidatedDates();

//     try {
//       const results = await Promise.all(
//         inverters.map(async (inv) => {
//           try {
//             const res = await axios.get(
//               `${BaseUrl}CMN_08InvLog/Get_Inv_Perf`,
//               {
//                 params: {
//                   ...credentials,
//                   MTR_NO: inv.feeder_id,
//                   DT1: start,
//                   DT2: end,
//                 },
//               }
//             );

//             const data = res.data?.data || [];

//             if (data.length > 0) {
//               const latest = data[data.length - 1];
//               const value = parseFloat(latest?.PR || 0);

//               return {
//                 name: inv.name,
//                 value: isNaN(value) ? 0 : value,
//               };
//             }
//           } catch (err) {
//             console.error("Error:", inv.name);
//           }

//           return null;
//         })
//       );

//       const filtered = results.filter(Boolean);
//       filtered.sort((a, b) => b.value - a.value);

//       const labels = filtered.map((i) => i.name);
//       const values = filtered.map((i) => i.value);

//       if (!labels.length) {
//         setChartData(null);
//       } else {
//         setChartData({
//           labels,
//           datasets: [
//             {
//               label: "PR",
//               data: values,
//               backgroundColor: values.map((v) =>
//                 v < idealValue ? "#FF4D4D" : "#28A745"
//               ),
//               borderColor: values.map((v) =>
//                 v < idealValue ? "#CC0000" : "#1E7E34"
//               ),
//               borderWidth: 1,
//               borderRadius: 6,
//             },
//           ],
//         });
//       }
//     } catch (err) {
//       console.error("Chart Error:", err);
//       setChartData(null);
//     }

//     setLoading(false);
//   };

//   useEffect(() => {
//     if (inverters.length > 0) {
//       fetchChartData();
//     }
//   }, [inverters, idealValue]);

//   return (
//     <div style={{ padding: "10px", background: "#f5f7fa" }}>
//       {/* 🔹 HEADER */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           mb: 2,
//           flexWrap: "wrap",
//           gap: 1,
//         }}
//       >
//         <Typography variant="h5" fontWeight="bold">
//           PR Performance
//         </Typography>

//         <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
//           <label>Ideal :</label>
//           <input
//             type="number"
//             value={idealValue}
//             onChange={(e) => setIdealValue(Number(e.target.value))}
//             style={{ width: "70px" }}
//           />

//           <label>Date:</label>
//           <input
//             type="date"
//             value={selectedDate}
//             max={new Date().toISOString().split("T")[0]}
//             onChange={(e) => setSelectedDate(e.target.value)}
//           />

//           {/* 🔥 Animated Refresh */}
//           <TbRefresh
//             size={30}
//             onClick={fetchChartData}
//             style={{
//               cursor: "pointer",
//               color: "#1976d2",
//               transition: "0.3s",
//             }}
//             onMouseOver={(e) =>
//               (e.currentTarget.style.transform = "rotate(90deg)")
//             }
//             onMouseOut={(e) =>
//               (e.currentTarget.style.transform = "rotate(0deg)")
//             }
//           />

//           <DownloadJpegButton
//             targetRef={chartRef}
//             fileName="PR Performance.jpeg"
//           />
//         </Box>
//       </Box>

//       {/* 🔥 CENTER CARD */}
//       <Box sx={{ display: "flex", justifyContent: "center" }}>
//         <Paper
//           ref={chartRef}
//           sx={{
//             p: 3,
//             width: "75%",
//             borderRadius: 3,
//             boxShadow: "0 6px 25px rgba(0,0,0,0.12)",
//           }}
//         >
//           <Box sx={{ height: 400 }}>
//             {loading ? (
//               <Typography align="center" mt={10}>
//                 Loading...
//               </Typography>
//             ) : chartData ? (
//               <Bar
//                 data={chartData}
//                 options={{
//                   indexAxis: "y",
//                   responsive: true,
//                   maintainAspectRatio: false,
//                   plugins: {
//                     legend: { display: false },
//                     datalabels: {
//                       anchor: "end",
//                       align: "right",
//                       formatter: (value) => value.toFixed(2),
//                       color: (ctx) => {
//                         const val = ctx.dataset.data[ctx.dataIndex];
//                         return val < idealValue
//                           ? "#FF0000"
//                           : "#008000";
//                       },
//                       font: { weight: "bold" },
//                     },
//                   },
//                   scales: {
//                     x: {
//                       beginAtZero: true,
//                       max: 100,
//                     },
//                   },
//                 }}
//               />
//             ) : (
//               <Typography align="center" mt={10}>
//                 No Data Found
//               </Typography>
//             )}
//           </Box>
//         </Paper>
//       </Box>
//     </div>
//   );
// }

// export default InvPrHorizontalPerformance;

// 2. EK DIN BACK DATA SHOW HO RAHA HAI

// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";
// import { TbRefresh } from "react-icons/tb";
// import { Paper, Typography, Box } from "@mui/material";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// // ❌ ChartDataLabels removed from global register
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );

// function InvPrHorizontalPerformance() {
//   const chartRef = useRef();

//   const [selectedDate, setSelectedDate] = useState(() => {
//     return new Date().toISOString().split("T")[0];
//   });

//   const [idealValue, setIdealValue] = useState(80);
//   const [inverters, setInverters] = useState([]);
//   const [chartData, setChartData] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const credentials = {
//     LOGIN_ID: localStorage.getItem("LoginID"),
//     LOC_CODE: localStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//     TYP: "I",
//   };

//   const getValidatedDates = () => {
//     let start = selectedDate;
//     const nextDay = new Date(start);
//     nextDay.setDate(nextDay.getDate() + 1);

//     let end = nextDay.toISOString().split("T")[0];

//     return { start, end };
//   };

//   // 🔹 Fetch Inverters
//   useEffect(() => {
//     const fetchInverters = async () => {
//       try {
//         const res = await axios.get(
//           `${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`,
//           { params: credentials }
//         );
//         setInverters(res.data?.FEED || []);
//       } catch (err) {
//         console.error("Inverter API Error:", err);
//       }
//     };

//     fetchInverters();
//   }, []);

//   // 🔹 Fetch Chart Data
//   const fetchChartData = async () => {
//     if (!inverters?.length) return;

//     setLoading(true);
//     const { start, end } = getValidatedDates();

//     try {
//       const results = await Promise.all(
//         inverters.map(async (inv) => {
//           //  console.log("Calling API for Feeder:", inv.feeder_id); 
//           try {
//             const res = await axios.get(
//               `${BaseUrl}CMN_08InvLog/Get_Inv_Perf`,
//               {
//                 params: {
//                   ...credentials,
//                   MTR_NO: inv.feeder_id,
//                   DT1: start,
//                   DT2: end,
//                 },
//               }
//             );

//             const data = res.data?.data || [];

//             if (data.length > 0) {
//               const latest = data[data.length - 1];
//               const value = parseFloat(latest?.PR || 0);

//               return {
//                 name: inv.name,
//                 value: isNaN(value) ? 0 : value,
//               };
//             }
//           } catch (err) {
//             console.error("Error:", inv.name);
//           }

//           return null;
//         })
//       );

//       const filtered = results.filter(Boolean);
//       filtered.sort((a, b) => b.value - a.value);

//       const labels = filtered.map((i) => i.name);
//       const values = filtered.map((i) => i.value);

//       if (!labels.length) {
//         setChartData(null);
//       } else {
//         setChartData({
//           labels,
//           datasets: [
//             {
//               label: "PR",
//               data: values,
//               backgroundColor: values.map((v) =>
//                 v < idealValue ? "#FF4D4D" : "#28A745"
//               ),
//               borderColor: values.map((v) =>
//                 v < idealValue ? "#CC0000" : "#1E7E34"
//               ),
//               borderWidth: 1,
//               borderRadius: 6,
//             },
//           ],
//         });
//       }
//     } catch (err) {
//       console.error("Chart Error:", err);
//       setChartData(null);
//     }

//     setLoading(false);
//   };

//   useEffect(() => {
//     if (inverters.length > 0) {
//       fetchChartData();
//     }
//   }, [inverters, idealValue]);

//   return (
//     <div style={{ padding: "10px", background: "#f5f7fa" }}>
//       {/* 🔹 HEADER */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           mb: 2,
//           flexWrap: "wrap",
//           gap: 1,
//         }}
//       >
//         <Typography variant="h5" fontWeight="bold">
//          Inverter PR
//         </Typography>

//         <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
//           <label>Ideal :</label>
//           <input
//             type="number"
//             value={idealValue}
//             onChange={(e) => setIdealValue(Number(e.target.value))}
//             style={{ width: "70px" }}
//           />

//           <label>Date:</label>
//           <input
//             type="date"
//             value={selectedDate}
//             max={new Date().toISOString().split("T")[0]}
//             onChange={(e) => setSelectedDate(e.target.value)}
//           />

//           {/* 🔥 Refresh */}
//           <TbRefresh
//             size={30}
//             onClick={fetchChartData}
//             style={{
//               cursor: "pointer",
//               color: "#1976d2",
//               transition: "0.3s",
//             }}
//           />

//           <DownloadJpegButton
//             targetRef={chartRef}
//             fileName="PR Performance.jpeg"
//           />
//         </Box>
//       </Box>

//       {/* 🔥 CENTER CARD */}
//       <Box sx={{ display: "flex", justifyContent: "center" }}>
//         <Paper
//           ref={chartRef}
//           sx={{
//             p: 3,
//             width: "75%",
//             borderRadius: 3,
//             boxShadow: "0 6px 25px rgba(0,0,0,0.12)",
//           }}
//         >
//           <Box sx={{ height: 400 }}>
//             {loading ? (
//               <Typography align="center" mt={10}>
//                 Loading...
//               </Typography>
//             ) : chartData ? (
//               <Bar
//                 data={chartData}
//                 plugins={[ChartDataLabels]} // ✅ local plugin
//                 options={{
//                   indexAxis: "y",
//                   responsive: true,
//                   maintainAspectRatio: false,
//                   plugins: {
//                     legend: { display: false },

//                     tooltip: {
//                       callbacks: {
//                         label: function (context) {
//                           return `PR: ${context.raw.toFixed(2)}`;
//                         },
//                       },
//                     },

//                     datalabels: {
//                       anchor: "end",
//                       align: "right",
//                       formatter: (value) =>
//                         value ? value.toFixed(2) : "0",
//                       color: (context) => {
//                         const value = context.raw;
//                         return value < idealValue
//                           ? "#FF0000"
//                           : "#008000";
//                       },
//                       font: { weight: "bold" },
//                     },
//                   },
//                   scales: {
//                     x: {
//                       beginAtZero: true,
//                       max: 100,
//                     },
//                   },
//                 }}
//               />
//             ) : (
//               <Typography align="center" mt={10}>
//                 No Data Found
//               </Typography>
//             )}
//           </Box>
//         </Paper>
//       </Box>
//     </div>
//   );
// }

// export default InvPrHorizontalPerformance;

// 3. SEQUENCE SAME NA HAI API JAISA

// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";
// import { TbRefresh } from "react-icons/tb";
// import { Paper, Typography, Box } from "@mui/material";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// // ✅ Removed global ChartDataLabels
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );

// function InvPrHorizontalPerformance() {
//   const chartRef = useRef();

//   // ✅ FIXED LOCAL DATE (NO UTC ISSUE)
//   const getLocalDate = () => {
//     const d = new Date();
//     d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
//     return d.toISOString().split("T")[0];
//   };

//   const [selectedDate, setSelectedDate] = useState(getLocalDate());
//   const [idealValue, setIdealValue] = useState(80);
//   const [inverters, setInverters] = useState([]);
//   const [chartData, setChartData] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const credentials = {
//     LOGIN_ID: localStorage.getItem("LoginID"),
//     LOC_CODE: localStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//     TYP: "I",
//   };

//   // ✅ FORMAT DATE FOR API (21-MAR-2026)
//   const formatDateForAPI = (dateStr) => {
//     const months = [
//       "JAN","FEB","MAR","APR","MAY","JUN",
//       "JUL","AUG","SEP","OCT","NOV","DEC"
//     ];

//     const date = new Date(dateStr);
//     const day = String(date.getDate()).padStart(2, "0");
//     const month = months[date.getMonth()];
//     const year = date.getFullYear();

//     return `${day}-${month}-${year}`;
//   };

//   // ✅ SAME DATE (NO NEXT DAY BUG)
//   const getValidatedDates = () => {
//     const start = formatDateForAPI(selectedDate);
//     const end = formatDateForAPI(selectedDate);

//     console.log("Selected Date:", selectedDate);
//     console.log("API Start:", start);
//     console.log("API End:", end);

//     return { start, end };
//   };

//   // 🔹 Fetch Inverters
//   useEffect(() => {
//     const fetchInverters = async () => {
//       try {
//         const res = await axios.get(
//           `${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`,
//           { params: credentials }
//         );
//         setInverters(res.data?.FEED || []);
//       } catch (err) {
//         console.error("Inverter API Error:", err);
//       }
//     };

//     fetchInverters();
//   }, []);

//   // 🔹 Fetch Chart Data
//   const fetchChartData = async () => {
//     if (!inverters?.length) return;

//     setLoading(true);
//     const { start, end } = getValidatedDates();

//     try {
//       const results = await Promise.all(
//         inverters.map(async (inv) => {
//           try {
//             console.log(`📡 API Hit → ${inv.name} | ${inv.feeder_id}`);

//             const res = await axios.get(
//               `${BaseUrl}CMN_08InvLog/Get_Inv_Perf`,
//               {
//                 params: {
//                   ...credentials,
//                   MTR_NO: inv.feeder_id,
//                   DT1: start,
//                   DT2: end,
//                 },
//               }
//             );

//             const data = res.data?.data || [];

//             if (data.length > 0) {
//               const latest = data[data.length - 1];
//               const value = parseFloat(latest?.PR || 0);

//               return {
//                 name: inv.name,
//                 value: isNaN(value) ? 0 : value,
//               };
//             }
//           } catch (err) {
//             console.error("Error:", inv.name);
//           }

//           return null;
//         })
//       );

//       const filtered = results.filter(Boolean);
//       filtered.sort((a, b) => b.value - a.value);

//       const labels = filtered.map((i) => i.name);
//       const values = filtered.map((i) => i.value);

//       if (!labels.length) {
//         setChartData(null);
//       } else {
//         setChartData({
//           labels,
//           datasets: [
//             {
//               label: "PR",
//               data: values,
//               backgroundColor: values.map((v) =>
//                 v < idealValue ? "#FF4D4D" : "#28A745"
//               ),
//               borderColor: values.map((v) =>
//                 v < idealValue ? "#CC0000" : "#1E7E34"
//               ),
//               borderWidth: 1,
//               borderRadius: 6,
//             },
//           ],
//         });
//       }
//     } catch (err) {
//       console.error("Chart Error:", err);
//       setChartData(null);
//     }

//     setLoading(false);
//   };

//   useEffect(() => {
//     if (inverters.length > 0) {
//       fetchChartData();
//     }
//   }, [inverters, idealValue]); // ✅ added selectedDate

//   return (
//     <div style={{ padding: "10px", background: "#f5f7fa" }}>
//       {/* HEADER */}
//       <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
//         <Typography variant="h5" fontWeight="bold">
//           Inverter PR
//         </Typography>

//         <Box sx={{ display: "flex", gap: 1 }}>
//           <label>Ideal :</label>
//           <input
//             type="number"
//             value={idealValue}
//             onChange={(e) => setIdealValue(Number(e.target.value))}
//             style={{ width: "70px" }}
//           />

//           <label>Date:</label>
//           <input
//             type="date"
//             value={selectedDate}
//             max={getLocalDate()}
//             onChange={(e) => setSelectedDate(e.target.value)}
//           />

//           <TbRefresh size={30} onClick={fetchChartData} style={{ cursor: "pointer" }} />

//           <DownloadJpegButton targetRef={chartRef} fileName="PR.jpeg" />
//         </Box>
//       </Box>

//       {/* CHART */}
//       <Box sx={{ display: "flex", justifyContent: "center" }}>
//         <Paper ref={chartRef} sx={{ p: 3, width: "75%" }}>
//           <Box sx={{ height: 400 }}>
//             {loading ? (
//               <Typography align="center">Loading...</Typography>
//             ) : chartData ? (
//               <Bar
//                 data={chartData}
//                 plugins={[ChartDataLabels]}
//                 options={{
//                   indexAxis: "y",
//                   responsive: true,
//                   maintainAspectRatio: false,
//                   plugins: {
//                     legend: { display: false },
//                     datalabels: {
//                       anchor: "end",
//                       align: "right",
//                       formatter: (v) => v.toFixed(2),
//                     },
//                   },
//                   scales: {
//                     x: { beginAtZero: true, max: 100 },
//                   },
//                 }}
//               />
//             ) : (
//               <Typography align="center">No Data Found</Typography>
//             )}
//           </Box>
//         </Paper>
//       </Box>
//     </div>
//   );
// }

// export default InvPrHorizontalPerformance;

import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { TbRefresh } from "react-icons/tb";
import { Paper, Typography, Box } from "@mui/material";
import { BaseUrl } from "../../../../../../api/AxiosApi";
import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function InvPrHorizontalPerformance() {
  const chartRef = useRef();

  const getLocalDate = () => {
    const d = new Date();
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
    return d.toISOString().split("T")[0];
  };

  const [selectedDate, setSelectedDate] = useState(getLocalDate());
  const [idealValue, setIdealValue] = useState(80);
  const [inverters, setInverters] = useState([]);
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(false);

  const credentials = {
    LOGIN_ID: localStorage.getItem("LoginID"),
    LOC_CODE: localStorage.getItem("LCODE"),
    PASS_KEY: "XYZ",
    WEB_KEY: "WEBXYZ321",
    TYP: "I",
  };

  const formatDateForAPI = (dateStr) => {
    const months = [
      "JAN","FEB","MAR","APR","MAY","JUN",
      "JUL","AUG","SEP","OCT","NOV","DEC"
    ];

    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const getValidatedDates = () => {
    const start = formatDateForAPI(selectedDate);
    const end = formatDateForAPI(selectedDate);
    return { start, end };
  };

  // 🔹 Fetch Inverters
  useEffect(() => {
    const fetchInverters = async () => {
      try {
        const res = await axios.get(
          `${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`,
          { params: credentials }
        );
        setInverters(res.data?.FEED || []);
      } catch (err) {
        console.error("Inverter API Error:", err);
      }
    };

    fetchInverters();
  }, []);

  // 🔹 Fetch Chart Data
  const fetchChartData = async () => {
    if (!inverters?.length) return;

    setLoading(true);
    const { start, end } = getValidatedDates();

    try {
      const results = await Promise.all(
        inverters.map(async (inv) => {
          try {
            const res = await axios.get(
              `${BaseUrl}CMN_08InvLog/Get_Inv_Perf`,
              {
                params: {
                  ...credentials,
                  MTR_NO: inv.feeder_id,
                  DT1: start,
                  DT2: end,
                },
              }
            );

            const data = res.data?.data || [];

            if (data.length > 0) {
              const latest = data[data.length - 1];
              const value = parseFloat(latest?.PR || 0);

              return {
                name: inv.name,
                value: isNaN(value) ? 0 : value,
              };
            }
          } catch (err) {
            console.error("Error:", inv.name);
          }

          return null;
        })
      );

      // ✅ Maintain API sequence (NO SORT)
      const filtered = results.filter(Boolean);

      const labels = filtered.map((i) => i.name);
      const values = filtered.map((i) => i.value);

      if (!labels.length) {
        setChartData(null);
      } else {
        setChartData({
          labels,
          datasets: [
            {
              label: "PR",
              data: values,
              backgroundColor: values.map((v) =>
                v < idealValue ? "#FF4D4D" : "#28A745"
              ),
              borderColor: values.map((v) =>
                v < idealValue ? "#CC0000" : "#1E7E34"
              ),
              borderWidth: 1,
              borderRadius: 6,
            },
          ],
        });
      }
    } catch (err) {
      console.error("Chart Error:", err);
      setChartData(null);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (inverters.length > 0) {  
      fetchChartData();
    }
  }, [inverters, idealValue]); // ✅ added selectedDate

  return (
    <div style={{ padding: "10px", background: "#f5f7fa" }}>
      {/* HEADER */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Typography variant="h5" fontWeight="bold">
          Inverter PR
        </Typography>

        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <label>Ideal :</label>
          <input
            type="number"
            value={idealValue}
            onChange={(e) => setIdealValue(Number(e.target.value))}
            style={{ width: "70px" }}
          />

          <label>Date:</label>
          <input
            type="date"
            value={selectedDate} 
            max={getLocalDate()}
            onChange={(e) => setSelectedDate(e.target.value)}
          />

          {/* ✅ Bigger Refresh Icon */}
          <TbRefresh
            size={32}
            onClick={fetchChartData}
            style={{ cursor: "pointer" }}
          />

          <DownloadJpegButton targetRef={chartRef} fileName="PR.jpeg" />
        </Box>
      </Box>

      {/* CHART */}
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Paper ref={chartRef} sx={{ p: 3, width: "75%" }}>
          <Box sx={{ height: 400 }}>
            {loading ? (
              <Typography align="center">Loading...</Typography>
            ) : chartData ? (
              <Bar
                data={chartData}
                plugins={[ChartDataLabels]}
                options={{
                  indexAxis: "y",
                  responsive: true,
                  maintainAspectRatio: false,
                  plugins: {
                    legend: { display: false },
                    datalabels: {
                      anchor: "end",
                      align: "right",
                      formatter: (v) => v.toFixed(2),
                    },
                  },
                  scales: {
                    x: { beginAtZero: true, max: 100 },
                  },
                }}
              />
            ) : (
              <Typography align="center">No Data Found</Typography>
            )}
          </Box>
        </Paper>
      </Box>
    </div>
  );
}

export default InvPrHorizontalPerformance;